// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 84 ? "9b0008ae" : chunkId) + "." + {"84":"4e0d4b407be40d1e","376":"7c835da45d4abfd9"}[chunkId] + ".js";
};